import { render, staticRenderFns } from "./formBox.vue?vue&type=template&id=4bed1e00&scoped=true"
import script from "./formBox.vue?vue&type=script&lang=js"
export * from "./formBox.vue?vue&type=script&lang=js"
import style0 from "./formBox.vue?vue&type=style&index=0&id=4bed1e00&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bed1e00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bed1e00')) {
      api.createRecord('4bed1e00', component.options)
    } else {
      api.reload('4bed1e00', component.options)
    }
    module.hot.accept("./formBox.vue?vue&type=template&id=4bed1e00&scoped=true", function () {
      api.rerender('4bed1e00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/news/components/formBox.vue"
export default component.exports